<script>
    import { selectedStudy, selectedSite, selectedParticipant } from '$stores/selectionStore';
    import { slide } from 'svelte/transition';
    import { isHeaderVisible } from '$stores/uiStore';
    import { config } from '$stores/configStore';
    import { user } from '$stores/sessionStore';
    
    export let title = '';
    
    // Computed properties to check if user has assigned studies/sites
    $: hasAssignedStudies = $user?.studyIds && $user.studyIds.length > 0;
    $: hasAssignedSites = $user?.siteIds && $user.siteIds.length > 0;
</script>
  
{#if $isHeaderVisible}
<div class="flex justify-between ph-2 pb-0" transition:slide|local>
    <h2 class="text-s mx-2 mb-1 text-sky-800 dark:text-sky-600">
        {#if !hasAssignedStudies}
            <a href="/studies" class="hover:underline">Home</a>
        {:else}
            <span>Home</span>
        {/if}
        {#if $selectedStudy}
            | {#if !hasAssignedSites}
                <a href="/sites" class="hover:underline">Study: {$selectedStudy.studyName} ({$selectedStudy.protocolNumber})</a>
            {:else}
                <span>Study: {$selectedStudy.studyName} ({$selectedStudy.protocolNumber})</span>
            {/if}
        {/if}
        {#if $selectedSite}
            | <a href="/persons" class="hover:underline">Site: {$selectedSite.siteName} ({$selectedSite.siteId})</a>
        {/if}
        {#if $selectedParticipant}
            | <a href="/person" class="hover:underline">Subject: {$selectedParticipant.subjectId}</a>
        {/if}
        {#if title !== null}
            {title}
        {/if}
    </h2> 
</div>
{/if}